import { useEffect } from "react";

/**
 * Bouton / geste "retour" d'Android.
 *
 * Sans ça, le retour Android FERME l'application au lieu de revenir à l'écran
 * précédent : la coque Capacitor ne connaît pas l'historique de navigation de
 * l'app React. On l'y branche donc explicitement, et on ne quitte l'app que
 * depuis l'accueil (comportement attendu sur Android).
 *
 * Sur iOS, le geste de balayage depuis le bord gauche est géré nativement par la
 * WebView (voir mobile/scripts/fix-ios-scene.sh), rien à faire ici.
 *
 * Le plugin est appelé via `window.Capacitor` plutôt qu'importé : le site web
 * n'embarque ainsi aucune dépendance mobile.
 */
export default function useNativeBackButton() {
  useEffect(() => {
    const cap = typeof window !== "undefined" ? window.Capacitor : null;
    if (!cap?.isNativePlatform?.()) return undefined;
    const AppPlugin = cap.Plugins?.App;
    if (!AppPlugin?.addListener) return undefined;

    let remove = null;
    const handler = () => {
      const atHome = window.location.pathname === "/" || window.location.pathname === "";
      if (!atHome && window.history.length > 1) {
        window.history.back();
      } else {
        AppPlugin.exitApp?.();
      }
    };

    const registration = AppPlugin.addListener("backButton", handler);
    Promise.resolve(registration)
      .then((handle) => {
        remove = handle?.remove ? () => handle.remove() : null;
      })
      .catch(() => {});

    return () => {
      if (remove) remove();
    };
  }, []);
}
